
import { Field } from "@smartsoftware/reflex-core";
import { DexResourceModel } from "../abstracts/dexResource.model";


export class Territory extends DexResourceModel
{

    @Field(String)
    public name: string = "";

	@Field(String)
	public description: string = "";

    @Field(String)
    public region_uuid?: string | null = null;

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

    public get data(): any {
        let json = super.data;

        return json;
    }
}
